import CityPageTemplate from "../city-template/CityPageTemplate";
import { jeffersontownConfig } from "./data";

export default function JeffersontownPage() {
  return <CityPageTemplate config={jeffersontownConfig} />;
}